import { observer } from 'src/utils/mobx-react';
import React from 'react';
import { PaymentDetailsHeader, PaymentDetailsTitle, PaymentDetailsWrapper, CloseButton } from './PaymentDetails.style';
import JsonView from '@microlink/react-json-view';

export const PaymentDetails = observer(
    'PaymentDetails',
    (props: { moreDetails: (value: boolean) => void; paymentResponseString: string }) => {
        const paymentResponseString = JSON.parse(props.paymentResponseString);

        return (
            <div className='audits visible'>
                <div className='audits-content'>
                    <CloseButton
                        className='audits-minimize'
                        onClick={(): void => {
                            props.moreDetails(false);
                        }}
                    />
                    <PaymentDetailsWrapper>
                        <PaymentDetailsHeader>
                            <PaymentDetailsTitle>Payment Details:</PaymentDetailsTitle>
                            <JsonView
                                src={paymentResponseString}
                                displayDataTypes={false}
                                collapsed={6}
                                name={null}
                                groupArraysAfterLength={1000}
                                style={{ fontSize: '14px' }}
                            />
                        </PaymentDetailsHeader>
                    </PaymentDetailsWrapper>
                </div>
            </div>
        );
    }
);
